<div class="h-100 w-100 d-flex flex-column align-items-center flex-grow-1 overflow-auto">

    <div class="position-absolute w-100 d-flex" [class.justify-content-end]="isRTL">
        <button type="button" mat-icon-button aria-label="Toggle sidenav" (click)="closeBorderExplainDialog()"
            class="close-icon d-flex align-items-center justify-content-center" [class.text-white]="isDarkMode">
            <mat-icon>close</mat-icon>
        </button>
    </div>

    <div class="d-flex flex-grow-1 flex-column align-items-center px-4 py-3 gap-2 w-100">
        <!-- title -->
        <h4 class="text-center fw-bold m-0 pt-3 pt-lg-2 px-3 px-lg-0 text-green zx-text-big" [class.zx-ltr]="!isRTL"
            [class.text-white]="isDarkMode" [class.zx-ltr]="!isRTL">
            {{ "border-explain.title" | translate }}
        </h4>
        <!-- explain -->
        <div class="d-flex flex-column gap-3 align-items-center w-100 pt-3">
            <span class="pb-2 text-center" [class.zx-ltr]="!isRTL" [class.text-start]="!isRTL" [class.zx-ltr]="!isRTL"
                [class.zx-text-white]="isDarkMode">
                {{ "border-explain.explain.1" | translate }}
            </span>
            <b class="pb-3 text-center" [class.zx-ltr]="!isRTL" [class.text-start]="!isRTL" [class.zx-ltr]="!isRTL"
                [class.zx-text-white]="isDarkMode">
                {{ "border-explain.explain.2" | translate }}
            </b>
        </div>
        <button type="button" mat-raised-button color="primary" class="w-100 rounded-pill zx-small-btn zx-text-white"
            (click)="closeBorderExplainDialog()">
            <b>
                {{ 'error-content-ok-btn' | translate }}
            </b>
        </button>
    </div>

</div>